export default function GenerateExampleCsv(): void {
	let csv = 'email,passcode\n';
	csv +=
		'user1@example.com,my-first-passcode\nuser2@example.com,my-second-passcode';

	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
	const link = document.createElement('a');
	link.setAttribute('href', URL.createObjectURL(blob));
	link.setAttribute('download', 'passcode-example.csv');
	link.style.visibility = 'hidden';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
